type CacheFindType = Promise<any>;

const cached = new Map();

const createCache = key => {
  let resolve, reject;
  const promise = new Promise((res, rej) => {
    resolve = res;
    reject = rej;
  });
  cached.set(key, { promise, resolve, reject });
  return { promise };
};

const cache = (key: string, data?: any): CacheFindType | void => {
  if (key && !data) return cache.find(key);
  if (key && data) cache.resolve(key, data);
};

cache.resolve = (key, data): void => {
  const query = cached.get(key);
  if (!query?.resolve) {
    createCache(key);
  }
  const { resolve } = cached.get(key);
  resolve(data);
};

cache.find = (key): CacheFindType => {
  const query = cached.get(key);
  if (query?.promise) {
    return query.promise;
  }
  const { promise } = createCache(key);
  return promise;
};

export default cache;
